// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "memberItem-3PvKI";
var _4 = "memberItem__avatar-_Ciq5";
var _5 = "memberItem__avatarSelf-3EFY7";
var _6 = "memberItem__data-3vZTC";
var _7 = "memberItem__dataName-3msSp";
var _8 = "memberItem_typeAdd-1p0Eq";
var _9 = "memberItem__dataInfo-3Fpic";
var _a = "memberItem__buttonRemove-Pjb-h";
var _b = "buttonRemove__text-1wfot";
export { _1 as "__esModule", _2 as "mobile", _3 as "memberItem", _4 as "memberItem__avatar", _5 as "memberItem__avatarSelf", _6 as "memberItem__data", _7 as "memberItem__dataName", _8 as "memberItem_typeAdd", _9 as "memberItem__dataInfo", _a as "memberItem__buttonRemove", _b as "buttonRemove__text" }
export default { "__esModule": _1, "mobile": _2, "memberItem": _3, "memberItem__avatar": _4, "memberItem__avatarSelf": _5, "memberItem__data": _6, "memberItem__dataName": _7, "memberItem_typeAdd": _8, "memberItem__dataInfo": _9, "memberItem__buttonRemove": _a, "buttonRemove__text": _b }
